import React from 'react';
import { getFormattedDuration } from 'src/utils/dateUtils';
import styled from 'styled-components';
import { Clock } from '@lt/components/icons-react';

const PopupTransfer = ({ transfer, airports, transferPrivate, isMobile, t }) =>
  transfer ? (
    <>
      <TransferTitle>
        {t('checkout.packageInfo.transfer.title', {
          context: transferPrivate ? 'private' : 'group',
        })}
      </TransferTitle>
      <div>
        <div>
          {t('checkout.packageInfo.transfer.airport')} &mdash;{' '}
          {t('filters.distance.hotel')} &mdash;{' '}
          {t('checkout.packageInfo.transfer.airport')}
        </div>

        <ul>
          {airports &&
            airports.map((airport) => (
              <Transfer isMobile={isMobile} key={airport.id}>
                <div>
                  {`${t('checkout.packageInfo.transfer.airportDistance')} ${
                    airport.name
                  }`}
                </div>
                <TransferTime>
                  <StyledClock />
                  {`${t(
                    'checkout.packageInfo.transfer.time',
                  )} ${getFormattedDuration(airport.transferTime)}`}
                </TransferTime>
              </Transfer>
            ))}
        </ul>
      </div>
    </>
  ) : (
    <span className="text">{t('checkout.packageInfo.transfer.text')}</span>
  );

const TransferTitle = styled.div`
  margin-bottom: 4px;
`;

const Transfer = styled.li<{ isMobile: boolean }>`
  align-items: flex-start;
  flex-direction: column;
  display: flex;
  column-gap: 5px;
`;

const TransferTime = styled.div`
  margin-top: 4px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  column-gap: 5px;
`;

const StyledClock = styled(Clock)`
  stroke: #4d4d4d;
  width: 16px;
  height: 16px;
`;

export default PopupTransfer;
